<h2 mat-dialog-title *ngIf="!loading">
  <mat-icon class="icon-20" >history_edu</mat-icon> Change Log
  <button mat-button mat-dialog-close="Cancel" aria-label="Close Log">Close</button>
  <div class="flex flex-row gap-[10px]">
    <section style="font-family: Oswald; font-size: 12pt;" class="flex flex-col">
      <mat-checkbox  [(ngModel)]="search.showRacialIdentity">Racial Identity</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showPrimaryRacialIdentity">Primary Racial Identity</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showWrittenLanguage">Written Language</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showSpokenLanguage">Spoken Language</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showBlind">Blind</mat-checkbox>
    </section>
    <section style="font-family: Oswald; font-size: 12pt;" class="flex flex-col">
      <mat-checkbox  [(ngModel)]="search.showDeaf">Deaf</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyWalking">Difficulty Walking</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyConcentrating">Difficulty Concentrating</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyDressing">Difficulty Dressing</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyLearning">Difficulty Learning</mat-checkbox>
    </section>
    <section style="font-family: Oswald; font-size: 12pt;" class="flex flex-col">
      <mat-checkbox  [(ngModel)]="search.showDifficultyCommunicating">Difficulty Communicating</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyErrands">Difficulty Errands</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showDifficultyMoods">Difficulty Moods</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showGenderIdentity">Gender Identity</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showSexualOrientation">Sexual Orientation</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showGender">Sex</mat-checkbox>
    </section>
    <section style="font-family: Oswald; font-size: 12pt;" class="flex flex-col">
      <mat-checkbox  [(ngModel)]="search.showIncome">Income</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showVeteranStatus">Veteran Status</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showCounty">County</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showVisitType">Visit Reason</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showAge">Age</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showClientData">Client Data</mat-checkbox>
      <mat-checkbox  [(ngModel)]="search.showNotes">Notes</mat-checkbox>
    </section>
  </div>
  <button mat-button (click)="showLogs()" color="primary" aria-label="Show Logs">Show Logs</button>
</h2>
<div *ngIf="!loading">
  <mat-card >
      <div class="flex flex-col gap-[8px_grid]">
          <br/>
          <div *ngFor="let log of auditlogs">
            <audit-log-table [auditLog]=log [LicenseId]="licenseId" [LicenseName]="licenseName"></audit-log-table>
          </div>
        <br />
        <div *ngIf="loading">
          <small>Loading...</small>
          <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
          </mat-progress-bar>
        </div>
        <button mat-button mat-dialog-close="Cancel" aria-label="Close Log">Close</button>
      </div>
  </mat-card>
</div>

<div *ngIf="loading">
  <div [ngClass]="{'loading': true, 'loading-dark': sharedService.darkMode}">
    <span>
      <h1>Loading</h1>
      <mat-spinner [diameter]="30"></mat-spinner>
    </span>
  </div>
</div>
